import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'app-add-audit-stage-record-dialog',
  templateUrl: './add-audit-stage-record-dialog.component.html',
  styleUrls: ['./add-audit-stage-record-dialog.component.scss']
})
export class AddAuditStageRecordDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  inputForm: any;

  constructor(private formBuilder: FormBuilder) {
    this.inputForm = this.formBuilder.group({
      nameOrNumber: ['', [Validators.required,
        Validators.pattern('[^\\\\/:*?\\"<>|]*')]]
    });
  }

  ngOnInit(): void {
    this.inputForm.valueChanges.subscribe(() => {
      this.data.isDisabledOkButton = this.inputForm.invalid;
    });
  }

  onOkClicked(): boolean {
    const nameOrNumber = this.inputForm.controls['nameOrNumber'];

    nameOrNumber.markAsTouched();

    if (nameOrNumber.hasError('required')) {
      return false;
    }

    this.data.input['nameOrNumber'] = nameOrNumber.value;

    return true;
  }

}
